import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { I18n } from "@/i18n/I18n";

type TruncatedTextWithModalProps = {
  text: string;
  maxLength?: number;
  className?: string;
  modalTitle?: string;
};

export function TruncatedTextWithModal({ 
  text, 
  maxLength = 150, 
  className,
  modalTitle
}: TruncatedTextWithModalProps) {
  const [showModal, setShowModal] = useState(false);
  const shouldTruncate = text.length > maxLength;
  const displayText = shouldTruncate 
    ? `${text.substring(0, maxLength)}...` 
    : text;

  return (
    <>
      <span className={className}>{displayText}</span>
      {shouldTruncate && (
        <Button
          variant="link"
          size="sm"
          className="p-0 text-decoration-none align-self-start d-block"
          onClick={() => setShowModal(true)}
        >
          {I18n.get('showMore')}
        </Button>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle ?? I18n.get('description')}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{text}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {I18n.get('close')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

